
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trust",
      function () {
        return require("private-next-pages/trust.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trust"])
      });
    }
  